import { mapRange } from '@wix/wow-utils';
import { roundNumber } from '../../utils';
const TRANSLATE_KEYFRAMES = [{
  keyframe: 17,
  translate: 7
}, {
  keyframe: 32,
  translate: 25
}, {
  keyframe: 48,
  translate: 8
}, {
  keyframe: 56,
  translate: 11
}, {
  keyframe: 66,
  translate: 25
}, {
  keyframe: 83,
  translate: 4
}, {
  keyframe: 100,
  translate: 0
}];
const POWER_TO_POKE_FACTOR_MAP = {
  soft: 1,
  medium: 2,
  hard: 4
};
const DIRECTION_MAP = {
  top: {
    axis: 'y',
    transformDirection: -1
  },
  bottom: {
    axis: 'y',
    transformDirection: 1
  },
  right: {
    axis: 'x',
    transformDirection: 1
  },
  left: {
    axis: 'x',
    transformDirection: -1
  }
};
export default function create(options) {
  const {
    power,
    intensity = 0.5,
    direction = 'right'
  } = options.namedEffect;
  const duration = options.duration || 0;
  const delay = +(options.delay || 0);
  const {
    axis,
    transformDirection
  } = DIRECTION_MAP[direction];
  const responsivePokeFactor = mapRange(0, 1, POWER_TO_POKE_FACTOR_MAP.soft, POWER_TO_POKE_FACTOR_MAP.hard, intensity);
  const pokeFactor = power ? POWER_TO_POKE_FACTOR_MAP[power] : responsivePokeFactor;
  const keyframes = TRANSLATE_KEYFRAMES.map(_ref => {
    let {
      keyframe,
      translate
    } = _ref;
    const translation = roundNumber(translate * pokeFactor * transformDirection);
    return {
      offset: keyframe / 100 * (duration / (duration + delay)),
      translate: axis === 'x' ? `${translation}px` : `0px ${translation}px`
    };
  });
  return [{
    ...options,
    delay: 0,
    duration: duration + delay,
    keyframes
  }];
  /*
   *
   * @keyframes <name> {
   *   <duration / (duration + delay)> {
   *     translate: ... ...,
   *   }
   *   100% {
   *     translate: 0 0,
   *   }
   * }
   *
   *
   * #target {
   *   animation: <name> <duration + delay> 0s infinite;
   * }
   */
}
//# sourceMappingURL=Poke.js.map